module.exports = __webpack_public_path__ + "static/media/010_Risco_Totem.51d9c809.mp4";